module.exports = __webpack_public_path__ + "static/media/banner.13fa8320.webp";